<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-chair_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">クラス管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'class' : 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-edit" @click="edit">
                編集
              </button>
            </td>
          </tr>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（教場ID）</th>
            <td>{{ currentSchoolDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名（コースID）</th>
            <td>{{ currentCourseDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名</th>
            <td>{{ currentTamaiClass.name }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名フリガナ</th>
            <td>{{ currentTamaiClass.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">クラスID（自動生成）</th>
            <td>{{ currentTamaiClass.uid }}</td>
          </tr>
          <tr>
            <th scope="row">先生名（担当・メイン）</th>
            <td>{{ currentMainTeacherDisplay }}</td>
          </tr>
          <tr v-for="index in maxNumOfTeacher" :key="index" v-show="currentTamaiClassTeacherDisplay(index)">
            <th scope="row">先生名（担当・サブ{{ index }}）</th>
            <td>{{ currentTamaiClassTeacherDisplay(index) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import {
  basicPresent,
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
} from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('tamai_class/fetchTamaiClass', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  mounted() {
    // 登録・編集の入力情報を初期化
    this.clearEditingTamaiClass();
  },
  computed: {
    currentTamaiClass() {
      return this.tamai_class.tamaiClass;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTamaiClass.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTamaiClass.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.currentTamaiClass.school);
    },
    currentCourseDisplay() {
      return basicCourseNameIdPresent(this.currentTamaiClass.course);
    },
    currentMainTeacherDisplay() {
      if (this.currentTamaiClass.mainTeacher) {
        return this.currentTamaiClass.mainTeacher.name;
      }
      return '';
    },
    ...mapState(['tamai_class']),
    ...mapGetters('tamai_class', ['maxNumOfTeacher']),
  },
  methods: {
    currentTamaiClassTeacherDisplay(index) {
      let teacher = this.currentTamaiClass['teacher' + index];
      if (teacher && teacher.id) {
        return basicPresent(teacher.name);
      }
      return null;
    },
    edit() {
      if (this.id) {
        this.$logger.debug('Edit Tamai Class ID ' + this.id);
        this.$router.push({ name: 'class-id-edit', params: { id: this.id } });
      }
    },
    ...mapActions('tamai_class', ['clearEditingTamaiClass']),
  },
};
</script>

<style scoped>
.btn {
  margin-left: 0px;
}
.btn-edit {
  margin-right: 20px;
}
</style>
